export default "__VITE_ASSET__57ffe0a8__"